module.exports = __webpack_public_path__ + "static/media/suggestion-CreativeCenter-desktop.654c6f77.png";